import Divider from '@mui/material/Divider';
import ListSubheader from '@mui/material/ListSubheader';
import PropTypes from 'prop-types';
import React from 'react';
import useBetweenMdXl from '../../../hooks/useBetweenMdXl';
import { useDefaultComponentValue } from '../../utils';
import { useIsExpandMode } from '../SidebarContext';
const COMPONENT_NAME = 'SidebarSubheader';
const SidebarSubheader = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { children, hideResponsiveDivider } = props;
    const betweenMdXl = useBetweenMdXl();
    const isExpandMode = useIsExpandMode();
    if (children && (!betweenMdXl || isExpandMode)) {
        return /*#__PURE__*/ React.createElement(ListSubheader, {
            sx: (theme)=>({
                    ...theme.typography.body1,
                    pt: 2,
                    pl: 2,
                    pb: 1,
                    color: 'text.primary',
                    transition: theme.transitions.create('opacity', {
                        duration: theme.transitions.duration.shorter
                    })
                })
        }, children);
    }
    if (betweenMdXl && !hideResponsiveDivider) {
        return /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                mb: 0.5
            }
        });
    }
    return null;
};
SidebarSubheader.propTypes = {
    children: PropTypes.node,
    hideResponsiveDivider: PropTypes.bool
};
export default SidebarSubheader;
